import { BellRing, Route } from "lucide-react";

import LxpAssetMobile from "@/../../hypetrain/static/img/exec-home/asset-lxp-mobile.png";
import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";
import { BaseLottieAnimation } from "@/components/pieces/animations/BaseLottieAnimation";

export function LearningPlatformCallout() {
  return (
    <div className="relative w-full overflow-hidden rounded-3xl bg-green-100">
      {/* Background image - hidden on mobile, visible on md+ */}
      <div
        className="absolute right-0 z-0 hidden h-full w-full max-w-xs md:block lg:max-w-sm xl:max-w-sm"
        style={{ overflow: "hidden" }}
      >
        <div
          className="h-full w-full"
          style={{ display: "flex", alignItems: "stretch", height: "100%" }}
        >
          <BaseLottieAnimation animationUrl="https://placement-pub.s3.us-east-2.amazonaws.com/lxp.json" />
        </div>
      </div>

      {/* Mobile-only image container that shows at the top on small screens */}
      <div className="block max-h-64 w-full overflow-hidden md:hidden">
        <EmbedSvg
          src={LxpAssetMobile}
          alt="Learning Experience Platform"
          className="w-full"
        />
      </div>

      {/* Content container - full width on mobile, 2/3 width on md+ */}
      <div className="flex w-full flex-col gap-6 px-6 py-9 md:w-2/3 md:gap-12 md:p-12 lg:p-16">
        <div className="max-w-2xl">
          <div className="mb-4 text-lg font-semibold text-green-800 md:text-2xl">
            Learning Experience Platform
          </div>

          <div className="text-2xl/snug font-semibold text-gray-800 md:text-3xl/snug">
            Design, manage, and measure all your programs from one intuitive
            platform
          </div>
        </div>

        <div className="flex flex-col gap-6 md:flex-row">
          <div className="flex flex-1 items-center gap-6 md:flex-col md:items-start">
            <div className="rounded-lg bg-green-200 p-2">
              <Route className="text-green-700" size={36} strokeWidth={1} />
            </div>
            <div className="text-gray-800">
              Sequence videos, surveys, articles, and more into structured
              learning paths.
            </div>
          </div>

          <div className="flex flex-1 items-center gap-6 md:flex-col md:items-start">
            <div className="rounded-lg bg-green-200 p-2">
              <BellRing className="text-green-700" size={36} strokeWidth={1} />
            </div>
            <div className="text-gray-800">
              Add notifications and nudges to drive engagement and keep
              participants on track.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
